import UnloadStatsPage from './pages/UnloadStats.page';
import ContainerDetailsPage from './pages/ContainerDetails.page';
import UnloadStatsBIPage from './pages/UnloadStatsBI.page';

UnloadStatsPage.path = '/unloads';
UnloadStatsBIPage.path = '/unloads/bi';
ContainerDetailsPage.path = '/containers/:id';

export default {
  pages: {
    UnloadStatsPage,
    ContainerDetailsPage,
    UnloadStatsBIPage,
  }
};
